import gsap from "gsap";




// HELPER FUNCTIONS
function debounce(func){
  var timer;
  return function(event){
    if(timer) clearTimeout(timer);
    timer = setTimeout(func,100,event);
  };
}




// FREEZE SCROLL
var freezeScroll = function() {
    document.querySelector('html').classList.add('no-scroll');
    document.body.classList.add('no-scroll','open-mobile-nav');
  };
  
  var unfreezeScroll = function() {
    document.querySelector('html').classList.remove('no-scroll');
    document.body.classList.remove('no-scroll','open-mobile-nav');
  };




// MOBILE NAVIGATION
var menuIcon = document.querySelector('.menu-icon');
var headerNavContainer = document.querySelector('.header__nav-container');
if(menuIcon && headerNavContainer){
    menuIcon.addEventListener('click',event=>{
        menuIcon.classList.toggle('menu-icon--active');
        if( menuIcon.classList.contains('menu-icon--active') ){
            openMenu();
        } else {
            closeMenu();
        }
    });
}

var openMenu = function() {
  headerNavContainer.classList.add('header__nav-container--active');
  setTimeout(function () {
      headerNavContainer.classList.add('header__nav-container--open');
  }, 10);
  freezeScroll();
};

var closeMenu = function() {
  headerNavContainer.classList.remove('header__nav-container--open');
  setTimeout(function () {
        headerNavContainer.classList.remove('header__nav-container--active');
    }, 500);
  unfreezeScroll();
};




// COMPACT HEADER
function manageCompactHeader(){
  var header = document.getElementById('header');
  var scrollPos = window.scrollY || window.scrollTop || document.querySelector('html').scrollTop;
  if (scrollPos < 50) {
    header.classList.remove('header--compact');
  } else {
    header.classList.add('header--compact');
  }
}
manageCompactHeader();
window.addEventListener('scroll', manageCompactHeader);




// SLIDERS
/*
var logoSlider = document.querySelector('.logos__items');
if( logoSlider ){
  var flkty = new Flickity( logoSlider, {
    // options
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: true
  });
}
*/

var quoteSlider = document.querySelector('.quotes__items');
if( quoteSlider ){
  var flkty = new Flickity( quoteSlider, {
    // options
    contain: true,
    // pageDots: false,
    // prevNextButtons: false,
    // wrapAround: true,
    // autoPlay: true,
    arrowShape: 'M66.1,0l3.6,2.6L35.8,50l33.9,47.4l-3.6,2.6L30.3,50L66.1,0z'
  });
}




// LOGOS SCROLL
let logoScroll;

const logosItems = document.getElementById('logos-items');
if(logosItems){
  logoScroll = gsap.fromTo("#logos-items", { xPercent: 25 }, { xPercent: -25, duration: getLogoScrollDuration(), ease: "none", repeat:-1 });
}

function getLogoScrollDuration(){
  let duration = windowSettings().orientation == 'vertical' && windowSettings().width < 768 ? 150 : 300;
  return duration;
}

function windowSettings(){
  return {
    'width' : window.innerWidth,
    'height' : window.innerHeight,
    'orientation' : window.innerWidth > window.innerHeight ? 'horizontal' : 'vertical'
  };
}

window.addEventListener("resize",debounce(function(e){
  if(logoScroll){
    logoScroll.duration(getLogoScrollDuration());
  }
}));